import _slicedToArray from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { StepConnector } from '@mui/material';
import { StepContent } from '@mui/material';
import { ASPENDENTAL_FONTS } from '../../../constants/constant';
import TAGSvgIcon from '../TAGSvgIcon/TAGSvgIcon';
import ErrorIcon from '@mui/icons-material/Error';

var TAGVerticalStepperPN = function TAGVerticalStepperPN(_ref) {
  var currentStep = _ref.currentStep,
      error = _ref.error,
      steps = _ref.steps;

  var _useState = useState(currentStep),
      _useState2 = _slicedToArray(_useState, 2),
      activeStep = _useState2[0],
      setActiveStep = _useState2[1];

  var handleNext = function handleNext() {
    if (error) {
      return null;
    }

    setActiveStep(function (prevActiveStep) {
      return prevActiveStep + 1;
    });
  };

  var handleReset = function handleReset() {
    setActiveStep(0);
  }; //NOTE: This function handles the ability to only be able to click and revert back to a previous completed step


  var handleStepClick = function handleStepClick(index) {
    if (error) {
      return null;
    } else if (activeStep > index) {
      return setActiveStep(index);
    }
  };

  var connector = React.createElement(StepConnector, {
    sx: {
      '&     .MuiStepConnector-lineVertical': {
        borderColor: 'neutrals.primary',
        borderLeftStyle: 'solid',
        borderLeftWidth: '1px'
      },
      '&.Mui-active': {
        '&	.MuiStepConnector-lineVertical': {
          borderColor: 'secondary.main',
          borderLeftStyle: 'solid',
          borderLeftWidth: '1px'
        }
      },
      '&.Mui-completed': {
        '&	.MuiStepConnector-lineVertical': {
          borderColor: 'secondary.main',
          borderLeftStyle: 'solid',
          borderLeftWidth: '1px'
        }
      }
    }
  });
  var STEPICONPROPS = {
    sx: {
      //NOTE: The standard color prop (Non Global Class) is defining the disabled state of the step
      color: 'neutrals.disabled',
      '&.Mui-active': {
        color: 'secondary.main'
      }
    }
  };
  var STEPCONTENTSTYLE = {
    '&.lastStep': {
      borderLeft: 'none'
    },
    borderLeft: "1px solid ".concat('secondary.main')
  };
  var STEPCONTTYPOG = {
    fontFamily: ASPENDENTAL_FONTS.lowestLevel.fontFamily,
    fontSize: ASPENDENTAL_FONTS.lowestLevel.fontSize,
    color: 'text.secondary',
    width: '400px'
  };

  var iconSwitch = function iconSwitch(index) {
    switch (true) {
      case activeStep === index && error:
        return React.createElement(ErrorIcon, {
          viewBox: '2 2 20 20',
          sx: {
            color: 'error.dark'
          }
        });

      case activeStep === index:
        return null;

      case activeStep < index:
        return null;

      case activeStep > index:
        return React.createElement(TAGSvgIcon, {
          icon: "CheckFunc",
          color: 'secondary.main',
          size: 24
        });
    }
  };

  var typographySwitch = function typographySwitch(index) {
    switch (true) {
      case activeStep === index && error:
        return 'error.dark';

      case activeStep === index:
        return 'secondary.dark';

      case activeStep > index:
        return 'secondary.main';

      default:
        return 'text.tertiary';
    }
  };

  return React.createElement(Box, {
    sx: {
      width: '100%'
    }
  }, React.createElement(Stepper, {
    activeStep: activeStep,
    orientation: "vertical",
    connector: connector
  }, steps.map(function (label, index) {
    return React.createElement(Step, {
      key: label.id
    }, React.createElement(StepLabel, {
      icon: iconSwitch(index),
      StepIconProps: STEPICONPROPS,
      sx: {
        padding: "".concat(activeStep > index ? '0px' : null)
      }
    }, React.createElement(Typography, {
      onClick: function onClick() {
        return handleStepClick(index);
      },
      sx: {
        fontFamily: ASPENDENTAL_FONTS.bodySmallBook.fontFamily,
        fontSize: ASPENDENTAL_FONTS.bodySmallBook.fontSize,
        color: "".concat(typographySwitch(index)),
        '&:hover': {
          textDecoration: "".concat(activeStep > index ? 'underline' : null),
          cursor: "".concat(activeStep > index ? 'pointer' : 'default')
        }
      }
    }, label.text)), index < activeStep && React.createElement(StepContent, {
      className: "".concat(index === steps.length - 1 && 'lastStep'),
      TransitionProps: {
        in: true
      },
      sx: STEPCONTENTSTYLE
    }, React.createElement(Typography, {
      key: label.id,
      sx: STEPCONTTYPOG
    }, label.description)));
  })), activeStep === steps.length ? React.createElement(React.Fragment, null, React.createElement(Typography, {
    sx: {
      mt: 2,
      mb: 1
    }
  }, "All steps completed - you're finished"), React.createElement(Box, {
    sx: {
      display: 'flex',
      flexDirection: 'row',
      pt: 2
    }
  }, React.createElement(Box, {
    sx: {
      flex: '1 1 auto'
    }
  }), React.createElement(Button, {
    onClick: handleReset
  }, "Reset"))) : React.createElement(React.Fragment, null, React.createElement(Typography, {
    sx: {
      mt: 2,
      mb: 1
    }
  }, "Step ", activeStep + 1), React.createElement(Box, {
    sx: {
      display: 'flex',
      flexDirection: 'row',
      pt: 2
    }
  }, React.createElement(Box, {
    sx: {
      flex: '1 1 auto'
    }
  }), React.createElement(Button, {
    onClick: handleNext
  }, activeStep === steps.length - 1 ? 'Finish' : 'Next'))));
};

export default TAGVerticalStepperPN;